/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
/**
 * author: tman
 */
import CardList from './CardList';
import Info from './Info';
import PanelGroupReview from './PanelGroupReview';
import UploadAddButton from './UploadAddButton';
import AOFormList from './AOFormList';
import UploadList from './UploadList'

export default {
    CardList,
    Info,
    PanelGroupReview,
    UploadAddButton,
    AOFormList,
    UploadList
}


// WEBPACK FOOTER //
// ./src/views/AOFormReview/components/index.js